import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, MessageCircleIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { WHATSAPP_URL } from '../data/content';
const BULLETS = ['Precio orientativo en 60 segundos.', 'Presupuesto cerrado tras revisión técnica.', 'Instalación limpia, planificada y bien rematada.'];
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/866e993a-c1c2-4ce8-9fc4-d0f080301caa.jpg';
export function Hero() {
  return <section id="top" className="relative isolate min-h-[92vh] w-full overflow-hidden bg-ink" data-id="element-272" data-mp="xa4hxe516dg4">
      <img src={HERO_IMAGE} alt="Salón de un piso de Barcelona con suelo de madera de roble de lama ancha" className="absolute inset-0 h-full w-full object-cover" data-id="element-273" data-mp="sai2qz5n6n4o" />
      <div className="absolute inset-0 bg-ink/65" aria-hidden="true" data-id="element-274" data-mp="3d1scx40hhvwa" />

      <div className="relative mx-auto flex min-h-[92vh] max-w-content flex-col justify-end px-6 pb-16 pt-32 lg:px-10 lg:pb-24" data-id="element-275" data-mp="382fedm0930dv">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-w-3xl" data-id="element-276" data-mp="3j898df6ywfql">
          <p className="text-[11px] font-medium uppercase tracking-overline text-champagne" data-id="element-277" data-mp="399bcfr77pjxk">
            Sistema Suelo Perfecto™ · Barcelona
          </p>

          <h1 className="mt-7 font-serif text-[2.6rem] font-light leading-[1.06] text-cream sm:text-6xl lg:text-[4.4rem]" data-id="element-278" data-mp="30i1abbi4kfh9">
            Renueva el suelo de tu vivienda sin sorpresas y con acabados de alto nivel
          </h1>

          <p className="mt-7 max-w-2xl text-[15px] leading-relaxed text-cream/75 lg:text-base" data-id="element-279" data-mp="2qkmsp8kgtknd">
            Instalamos parquet, laminado y vinílico con un sistema completo: asesoría, medición,
            planificación, rodapiés, ajuste de puertas y remates finales.
          </p>

          <ul className="mt-9 flex flex-col gap-3 border-l border-champagne/40 pl-5 sm:flex-row sm:flex-wrap sm:gap-x-8 sm:gap-y-3 sm:border-l-0 sm:pl-0" data-id="element-280" data-mp="2lkiks6xmhy8r">
            {BULLETS.map(b => <li key={b} className="flex items-start gap-2.5 text-[13.5px] text-cream/85" data-id="element-281" data-mp="nbb9spq0zv12">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-champagne" aria-hidden="true" data-id="element-282" data-mp="ic873bxiq0w9" />
                {b}
              </li>)}
          </ul>

          <div className="mt-11 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-283" data-mp="deq4e3a3ghwp">
            <CtaButton href="#calculadora" variant="cream" data-id="element-284" data-mp="1azkutpff0er5">
              Calcular mi suelo
            </CtaButton>
            <CtaButton href={WHATSAPP_URL} variant="light" external icon={<MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-286" data-mp="114stcaipp7r3" />} data-id="element-285" data-mp="162m137zny9th">
              Pedir presupuesto por WhatsApp
            </CtaButton>
          </div>

          <p className="mt-5 text-[12px] text-cream/55" data-id="element-287" data-mp="3luiawvasv7nh">
            Sin compromiso. Respondemos con una orientación real antes de venderte nada.
          </p>
        </motion.div>
      </div>
    </section>;
}